import { useEffect, useState } from 'react';
import { adminApi } from '../api/adminClient';

let cache: { value: boolean; at: number } | null = null;
const TTL_MS = 60_000;

export function useIsOperator(): { isOperator: boolean; loading: boolean } {
  const [isOperator, setIsOperator] = useState<boolean>(cache?.value ?? false);
  const [loading, setLoading] = useState<boolean>(!cache || Date.now() - cache.at > TTL_MS);

  useEffect(() => {
    if (cache && Date.now() - cache.at < TTL_MS) {
      setIsOperator(cache.value);
      setLoading(false);
      return;
    }
    let cancelled = false;
    adminApi.me()
      .then((r) => {
        if (cancelled) return;
        cache = { value: !!r.is_operator, at: Date.now() };
        setIsOperator(cache.value);
      })
      .catch(() => {
        if (cancelled) return;
        cache = { value: false, at: Date.now() };
        setIsOperator(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { isOperator, loading };
}
